// Lock background page scroll while the cart drawer/modal is open.
//
// Root cause of "scrolling inside the open cart drawer sometimes scrolls the
// page underneath instead": native [popover] elements do NOT automatically
// lock background scroll the way <dialog>.showModal() does, and nothing
// else in this theme ever did either.
//
// THIRD attempt at this fix. Both previous attempts - position:fixed body
// shift, then a lighter documentElement/body { overflow: hidden } toggle -
// reliably stopped background scroll, but BOTH also broke the drawer's
// additional payment method buttons (Shop Pay / PayPal / Amazon Pay / etc,
// rendered as third-party iframes via content_for_additional_checkout_buttons)
// on real mobile devices, confirmed directly: on a build with this script
// disabled the buttons render fine on mobile; re-enabling either previous
// version made them disappear again. Since that happened with TWO otherwise-
// different techniques, the common thread isn't which CSS property was used
// - it's that ANY change to <body>/<html>'s own position/overflow while
// those iframes are mounting is enough to trip whatever visibility/mount
// check they run (plausibly a deliberate anti-clickjacking measure, given
// position:fixed + overflow manipulation is also the exact technique used by
// malicious invisible-iframe-overlay attacks).
//
// This version never touches document.body or document.documentElement's
// style at all - no overflow, no position, no width. It relies purely on
// intercepting the scroll-causing DOM events themselves (touchmove for
// mobile swipes, wheel for trackpad/mouse) at the document level, and only
// preventing their default action when the gesture did NOT start inside a
// legitimate scrollable area (the drawer's own .mini-cart__scroll-area, the
// search sidebar's content, or a modal's inner wrapper) - gestures starting
// inside those still scroll completely normally. Since nothing about the
// page's own CSS ever changes, there is nothing here for a payment iframe's
// mount check to react to.
(function() {
  var locked = false;

  function isInsideAllowedScrollArea(target) {
    return !!(target.closest && (
      target.closest('.mini-cart__scroll-area') ||
      target.closest('.sidebar--drawer_content') ||
      target.closest('.modal__inner-wrapper')
    ));
  }

  function preventBackgroundScroll(event) {
    if (isInsideAllowedScrollArea(event.target)) return;
    event.preventDefault();
  }

  function lock() {
    if (locked) return;
    locked = true;
    document.addEventListener('touchmove', preventBackgroundScroll, { passive: false });
    document.addEventListener('wheel', preventBackgroundScroll, { passive: false });
  }

  function unlock() {
    if (!locked) return;
    locked = false;
    document.removeEventListener('touchmove', preventBackgroundScroll, { passive: false });
    document.removeEventListener('wheel', preventBackgroundScroll, { passive: false });
  }

  function attach(el) {
    if (!el) return;
    el.addEventListener('toggle', function(event) {
      if (event.newState === 'open') {
        lock();
      } else {
        unlock();
      }
    });
  }

  attach(document.getElementById('slideout-ajax-cart'));
  attach(document.getElementById('modal-ajax-cart'));
})();
